import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import { FAQ, PRIVACY_POLICY, LEGAL_NOTICE, CGU, CUSTOMER_REVIEWS, TERMS_CONDITIONS_PRO } from '~/const/faq';
import USE_MARKETPLACE from '~/const/marketplace';
import marketClosed from '~/helpers/marketClosed';
var MdmLink = () => import('~/components/atoms/MdmLink.vue');
export default {
  name: 'Mentions',
  components: {
    MdmLink
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    getDate() {
      var d = new Date();
      return d.getFullYear();
    },
    setLocale() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    },
    helpAndFaqsLinks() {
      return FAQ.find(faq => faq.language === this.locale.iso).url;
    },
    termsAndConditionsPro() {
      var _TERMS_CONDITIONS_PRO;
      return ((_TERMS_CONDITIONS_PRO = TERMS_CONDITIONS_PRO.find(term => term.language === this.locale.iso)) === null || _TERMS_CONDITIONS_PRO === void 0 ? void 0 : _TERMS_CONDITIONS_PRO.label) || null;
    },
    legalNoticeLinks() {
      return LEGAL_NOTICE.find(legalNotice => legalNotice.language === this.locale.iso).url;
    },
    privacyPolicyLinks() {
      return PRIVACY_POLICY.find(privacyPolicy => privacyPolicy.language === this.locale.iso).url;
    },
    customerReviewsLinks() {
      return CUSTOMER_REVIEWS.find(customerReviewLink => customerReviewLink.language === this.locale.iso).url;
    },
    cguLinks() {
      var _CGU$find;
      return (_CGU$find = CGU.find(cgu => cgu.language === this.locale.iso)) === null || _CGU$find === void 0 ? void 0 : _CGU$find.links;
    },
    isMarketplaceOpen() {
      return USE_MARKETPLACE(this);
    },
    isMarketOpen() {
      if (!this.locale) return true;
      var {
        market
      } = this.locale;
      return !marketClosed({
        market
      });
    }
  }),
  methods: {
    editCookies() {
      if (window.tC && window.tC.privacyCenter) {
        window.tC.privacyCenter.showPrivacyCenter();
      }
      return false;
    }
  }
};